// extracted by css-extract-rspack-plugin
export default {"root":"EmailTemplatesPopover_root__n+5wC","paper":"EmailTemplatesPopover_paper__DIpV5"};